import { render, staticRenderFns } from "./assignable-trajectories.vue?vue&type=template&id=6b6cec2b"
import script from "./assignable-trajectories.vue?vue&type=script&lang=js"
export * from "./assignable-trajectories.vue?vue&type=script&lang=js"
import style0 from "./assignable-trajectories.vue?vue&type=style&index=0&id=6b6cec2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports